import { useToggleConversation } from '@modules/chat-channels/hooks/useToggleConversation';
import { LoadingButton } from '@mui/lab';
import { Button, Stack, Typography } from '@mui/material';
import { useTheme } from '@mui/system';
import { useNavigate } from 'react-router';
import { IChatConversation } from 'src/@types/chat';
import { routes } from 'src/Router';
import { CPConfirm } from 'src/components/base/CPConfirm/CPConfirm';
import { CustomAvatar } from 'src/components/custom-avatar';
import Iconify from 'src/components/iconify';
import { useWorkspaceUser } from 'src/hooks/useWorkspace';
import { useLocales } from 'src/locales';
import { useChatConversationContext } from 'src/sections/@dashboard/chat/ChatConversation/useChatConversationContext';
import { StyledChatInitialStateContainer } from './styles';

type Props = {
  conversation: IChatConversation;
};

export const P2PInitialState = ({ conversation }: Props) => {
  const theme = useTheme();
  const { translate } = useLocales();
  const otherUser = useWorkspaceUser(conversation.chatPartner?.user || '');

  const { handleTextMessage } = useChatConversationContext();

  const { toggleConversation, isTogglingConversation } =
    useToggleConversation();
  const navigate = useNavigate();

  const handelDeleteChannel = async () => {
    await toggleConversation({ channelId: conversation._id, hide: true });
    navigate(routes.dashboard.chat.root);
  };

  const onSend = () => {
    const message = '<p>Hello! <em-emoji id="wave"></em-emoji> </p>';
    handleTextMessage(message);
  };

  return (
    <StyledChatInitialStateContainer>
      <CustomAvatar
        alt={otherUser?.name}
        src={otherUser?.picture}
        name={otherUser?.name}
        sx={{
          width: 64,
          height: 64,
          fontSize: '2em',
        }}
      />
      <Typography variant="h4">{otherUser?.name}</Typography>
      <Stack
        direction="row"
        alignItems="center"
        color="text.secondary"
        gap={0.5}
      >
        <Typography>
          {translate('communicate.direct.initial_state.subtitle')}
        </Typography>
        <Typography variant="subtitle1">{otherUser?.name}</Typography>
      </Stack>

      <Stack direction="row" alignItems="center" gap={1.5}>
        <Button
          variant="outlined"
          sx={{
            borderColor: theme.palette.divider,
            color: theme.palette.text.primary,
          }}
          onClick={onSend}
        >
          {translate('communicate.initial_state.say_hello')} 👋
        </Button>
        <CPConfirm onConfirm={handelDeleteChannel}>
          <LoadingButton
            variant="outlined"
            color="error"
            loading={isTogglingConversation}
            startIcon={<Iconify icon="tabler:trash" />}
            sx={{
              borderColor: theme.palette.divider,
              color: theme.palette.text.primary,
            }}
          >
            {translate('shared.buttons.remove_dm')}
          </LoadingButton>
        </CPConfirm>
      </Stack>
    </StyledChatInitialStateContainer>
  );
};
